export const ru = {
    cancel: 'Отмена',
    date: 'Дата',
    input_new_dates: 'Введите новые даты',
    placeholder_date: 'дд.мм.гггг',
    save: 'Сохранить',
};
